export default "__VITE_ASSET__Dfo57fZj__"